module.exports = __webpack_public_path__ + "img/absolut-age-confirm-mobile-img.1a1f5182.png";